"use client"

import { towerTypes } from "@/data/tower-types"
import { TowerThumbnail } from "./tower-thumbnail"
import { TowerDetails } from "./tower-details"

interface TowersCodexContentProps {
  selectedTowerId: string | null
  onSelectTower: (towerId: string | null) => void
  isEntityUnlocked: (entityId: string) => boolean
}

// Order of towers to display
const TOWER_ORDER = ["archer", "mage", "siege", "barracks", "shadowblade", "shrine"]

export const TowersCodexContent = ({
  selectedTowerId,
  onSelectTower,
  isEntityUnlocked,
}: TowersCodexContentProps) => {
  // Thumbnails content
  const thumbnailsContent = (
    <>
      {TOWER_ORDER.map((towerId) => {
        const tower = towerTypes[towerId]
        if (!tower) return null

        const isLocked = !isEntityUnlocked(towerId)
        const isSelected = selectedTowerId === towerId

        return (
          <TowerThumbnail
            key={towerId}
            towerId={towerId}
            towerName={tower.name}
            isSelected={isSelected}
            isLocked={isLocked}
            onClick={() => {
              if (!isLocked) {
                onSelectTower(isSelected ? null : towerId)
              }
            }}
          />
        )
      })}
    </>
  )

  // Details content
  const detailsContent = selectedTowerId ? (
    <TowerDetails tower={towerTypes[selectedTowerId]} />
  ) : null

  const present = TOWER_ORDER.filter((id) => towerTypes[id])

  return {
    thumbnailsContent,
    detailsContent,
    hasSelection: selectedTowerId !== null,
    total: present.length,
    discovered: present.filter((id) => isEntityUnlocked(id)).length,
  }
}
